<div class="wizard-step-container">
  <div class="wizard-step-header">
    <h1 class="wizard-step-title" role="heading" aria-level="1">{{title}}</h1>
    <p class="wizard-step-subtitle" role="heading" aria-level="2">
      <span *ngIf="!isSingleIndustry && isEnglish">{{subtitleBeginning}}<strong>{{subtitleMiddle}}</strong>{{subtitleEnd}}</span>
      <span *ngIf="!isSingleIndustry && !isEnglish">{{i18nSubtitle}}</span>
      <span *ngIf="isSingleIndustry">We've identified your <strong>industry</strong> as...</span>
    </p>
  </div>
  <div *ngIf="isSingleIndustry" role="main">
    <div class="columns is-multiline is-mobile is-centered is-gapless wizard-tile-wrapper-container">
      <div *ngFor="let primaryUse of primaryUseOptions; index as i" class="column">
        <app-wizard-tile
          [selectionType]="'radio'"
          [currentStepName]="analyticsStepName"
          [wizardOption]="primaryUse"
          [isSelected]="primaryUse.isSelected"
          [isAlignTextLeft]="true"
          [isSingleOption]="isSingleIndustry"
          [removeBottomPadding]="true"
          (onSelectEvent)="onSelect($event)"></app-wizard-tile>
      </div>
    </div>
  </div>

  <fieldset [attr.aria-label]="title">
    <div *ngIf="!isSingleIndustry" class="multi-industry-container">
      <div role="radiogroup" class="columns is-multiline is-mobile is-centered is-gapless wizard-tile-wrapper-container">
        <div
          *ngFor="let primaryUse of primaryUseOptions; index as i"
          class="column is-full-mobile is-3-tablet is-2-desktop">
          <app-wizard-tile
            [selectionType]="'radio'"
            [currentStepName]="analyticsStepName"
            [wizardOption]="primaryUse"
            [isSelected]="primaryUse.isSelected"
            [isAlignTextLeft]="true"
            [removeBottomPadding]="true"
            (onSelectEvent)="onSelect($event)"></app-wizard-tile>
        </div>
      </div>
    </div>
  </fieldset>

  <div *ngIf="isSingleIndustry">
    <a class="link not-your-industry-link"
      target="_blank"
      [attr.href]="notYourIndustryLinkUrl"
      [attr.aria-label]="notYourIndustryLinkText">{{notYourIndustryLinkText}}</a>
  </div>

  <div class="flex-information" *ngIf="showFlexLink">
    <p>
    Modernize your existing devices today with
    <a (click)="logLinkClick()">
       ChromeOS Flex.
      </a>
    </p>
  </div>

</div>
<div class="bottom-nav-items">
  <app-wizard-navigation
  role="navigation"
  [currentStepName]="analyticsStepName"
  [currentStepNumber]="stepNumber"
  [disableContinueButton]="isContinueBtnDisabled"
  [nextStepRoute]="'/use-case'"
  [hideBackButton]="true"
  [hasSkipButton]="false"
  (onSkipPressed)="onSkip()"></app-wizard-navigation>
  <app-progress-bar role="progressbar" aria-hidden="true" aria-label="Chromebook Selector progress bar" [step]="currentStep" [stepNumber]="stepNumber"></app-progress-bar>
</div>